/* Titles */

export const ITEM = "Ítem";
export const LAW = "Ley XXII N° 25 (Antes ley 3348)";
export const PRICE = "Costo";
export const AMOUNT = "Cantidad";
export const FISCAL_VALUE = "Valor Fiscal";
export const PERCENTAGE = "Porcentaje";
export const AMOUNT_LOTS = "Cant. lotes/UF";
export const URGENT = "Urgente";
export const SUB_TOTAL = "Subtotal";

/* Accessors */

/*export const ACC_ARTICLE = "articulo";
export const ACC_PRICE = "costo";
export const ACC_AMOUNT = "cantidad";
export const ACC_FISCAL_VALUE = "valorFiscal";
export const ACC_PERCENTAGE = "porcentaje";
export const ACC_AMOUNT_LOTS = "lotesUf";
export const ACC_URGENT = "urgente";
export const ACC_SUB_TOTAL = "subTotal";*/

export const ACC_ARTICLE = "articleName";
export const ACC_PRICE = "price";
export const ACC_AMOUNT = "amount";
export const ACC_FISCAL_VALUE = "fiscalValue";
export const ACC_PERCENTAGE = "percentage";
export const ACC_AMOUNT_LOTS = "lotAmount";
export const ACC_URGENT = "urgent";
export const ACC_SUB_TOTAL = "subtotal";
export const ACC_DESCRIPTION = "articleDescription";

/* Useful arrays */

export const TITLES = [ITEM, LAW, PRICE, AMOUNT, FISCAL_VALUE, PERCENTAGE, AMOUNT_LOTS, URGENT, SUB_TOTAL];
export const ACCESSORS = [
  ACC_ARTICLE,
  ACC_PRICE,
  ACC_AMOUNT,
  ACC_FISCAL_VALUE,
  ACC_PERCENTAGE,
  ACC_AMOUNT_LOTS,
  ACC_URGENT,
  ACC_SUB_TOTAL,
  ACC_DESCRIPTION,
];

/* Others */

export const ID = "Demo";
export const WIDTH = "100%";
